module.exports = __webpack_public_path__ + "static/media/verdeInternal.ad4a3110.jpg";